const MY_QUES_LIST = 'FETCH_MY_QUES_LIST';

export const fetchMyQuesAction = data => {
	return {
		type: 'FETCH_MY_QUES_LIST',
		payload: data
	}
}